import { scorerPrefix } from "../../default";

type ColumnsObject = Record<string, any>;

export function flattenColumns(
	obj: ColumnsObject,
	prefix = "",
): [string, number][] {
	const result: [string, number][] = [];

	for (const [key, value] of Object.entries(obj)) {
		const newKey = prefix ? `${prefix}.${key}` : key;

		if (typeof value === "object" && value !== null) {
			if ("position" in value) {
				result.push([`${scorerPrefix}${newKey}`, value.position]);
			} else if (Array.isArray(value)) {
				value.forEach((el) => {
					result.push(...flattenColumns(el, newKey));
				});
			} else {
				result.push(...flattenColumns(value, newKey));
			}
		}
	}

	return result;
}
